function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { faCheckCircle, faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';
import { Case, Default, Switch } from 'react-if';
import useHover from '../../hooks/use-hover';
import { HomeBlock, HomeBlockContent, HomeBlockTitle } from '../styled';
import { NotificationBlock, NotificationContentBlock, NotificationDescription, NotificationIcon as BaseNotificationIcon, NotificationIconButton } from './styled';
export const NotificationIcon = withTheme(_ref => {
  let {
    theme,
    notification,
    onClick,
    ...restProps
  } = _ref;
  const [isNotificationHovered, bindNotificationHover] = useHover();
  const isNotificationReadable = !notification.isRead && !notification.bypassReadable;
  return /*#__PURE__*/React.createElement(NotificationIconButton, _extends({}, isNotificationReadable && !notification.action ? bindNotificationHover() : {}, {
    isReadable: isNotificationReadable,
    isHovered: isNotificationHovered,
    onClick: onClick,
    notification: notification
  }, restProps), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Case, {
    condition: () => notification.isReading || notification.isRead && notification.wasJustRead
  }, () => /*#__PURE__*/React.createElement(BaseNotificationIcon, {
    icon: faCheckCircle,
    color: theme.colors.primary,
    size: "2x",
    transform: "shrink-4 up-1",
    notification: notification
  })), /*#__PURE__*/React.createElement(Case, {
    condition: () => notification.isRead
  }, () => /*#__PURE__*/React.createElement(BaseNotificationIcon, {
    icon: faCheckCircle,
    color: theme.colors.medium,
    size: "2x",
    transform: "shrink-4 up-1",
    notification: notification
  })), /*#__PURE__*/React.createElement(Case, {
    condition: () => isNotificationReadable && isNotificationHovered
  }, () => /*#__PURE__*/React.createElement(BaseNotificationIcon, {
    icon: faCheckCircle,
    color: theme.colors.primary,
    size: "2x",
    transform: "shrink-4 up-1",
    notification: notification
  })), /*#__PURE__*/React.createElement(Default, null, () => /*#__PURE__*/React.createElement(BaseNotificationIcon, {
    icon: faInfoCircle,
    color: theme.colors.tertiary,
    size: "2x",
    transform: "shrink-4 up-1",
    notification: notification
  }))));
});
const Notification = withTheme(_ref2 => {
  let {
    notification,
    onReadRequested
  } = _ref2;
  return /*#__PURE__*/React.createElement(NotificationBlock, {
    notification: notification
  }, /*#__PURE__*/React.createElement(NotificationIcon, {
    notification: notification,
    onClick: onReadRequested
  }), /*#__PURE__*/React.createElement(NotificationContentBlock, null, /*#__PURE__*/React.createElement(NotificationDescription, {
    notification: notification
  }, notification.meta.text)));
});
const notificationSchema = {
  title: PropTypes.string,
  isRead: PropTypes.boolean,
  meta: PropTypes.object
};
Notification.propTypes = {
  notification: PropTypes.shape(notificationSchema).isRequired,
  onReadRequested: PropTypes.func
};
const NotificationsView = _ref3 => {
  let {
    notifications,
    onReadRequested
  } = _ref3;
  return /*#__PURE__*/React.createElement(HomeBlock, null, /*#__PURE__*/React.createElement(HomeBlockTitle, null, "Mes notifications"), /*#__PURE__*/React.createElement(HomeBlockContent, null, notifications.map((notification, index) => /*#__PURE__*/React.createElement(Notification, {
    key: `${index}-${notification.id}`,
    notification: notification,
    onReadRequested: onReadRequested && onReadRequested.bind(null, notification._id)
  }))));
};
NotificationsView.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape(notificationSchema)),
  onReadRequested: PropTypes.func
};
export default NotificationsView;